/**
 * MePrFoService is a singleton instance of the MePrFoService class.
 * It is used to interact with the MePrFo service.
 *
 * This file injects Snowball app dependencies into the MePrFoService.
 */
import {
  createMePrFoService,
  type TopicAwarenessResult,
  type MePrFoService as MePrFoServiceType,
  type ContactLike,
  type UserWithTail,
  type InvitePreview,
  type ReceivedUpdateLike,
} from '@snowball/meprfo';

import { apiCall } from '@/util/api';

export {
  type MessageIntent,
  type TopicAwareness,
  type TopicAwarenessMap,
  type TopicAwarenessResult,
  type SharingLegLike,
  type ReshareInfoLike,
  type LegStoryInfoLike,
  type StoryRequest,
  type FictionalStoryRequest,
} from '@snowball/meprfo';

export type { ContactLike, UserWithTail, InvitePreview, ReceivedUpdateLike };
export type { PhoneLookupResult } from '@snowball/meprfo';
export type {
  PastRecipientMatch,
  PastRecipientsResult,
  UpdateCandidateLike,
} from '@snowball/meprfo';

export const MePrFoService: MePrFoServiceType = createMePrFoService({
  apiCall,
  logger: console,
});

export function checkTopicAwareness(
  topicId: string,
  contactLikes: ContactLike[]
): Promise<TopicAwarenessResult> {
  return MePrFoService.checkTopicAwareness(topicId, contactLikes);
}
